module.exports = __webpack_public_path__ + "static/desktop/img/params.d9f154de.png";